import React from 'react';
import { Box } from '@mui/material';

export const DELETE_SELECTION_COPY = {
  title: 'Delete selection?',
  text: 'Some selected entities cannot be deleted because weight values are assigned to them. This action cannot be undone.',
  textAllDeletable: (names: string[]) => (
    <>
      Are you sure that you want to delete the entity{' '}
      <Box component="span" sx={{ color: 'grey.1000' }}>
        {names.join(', ')}
      </Box>
      ?{'\n'}This action cannot be undone.
    </>
  ),
  backNameAllDeletable: 'Back',
  toChangeTitle: 'Will be deleted',
  toSkipTitle: 'Cannot be deleted',
  confirmName: 'Delete entities',
  assetText:
    'This selection includes an asset. Deleting it removes the entire asset risk assessment model, not just the selected entities.\nThis action cannot be undone.',
  assetConfirmName: 'Confirm',
  assetSuccess: 'Asset risk assessment model has been successfully deleted',
  allBlockedError:
    "All selected entities can't be deleted because they have AND relationships with the last auto-assigned weight value. Delete those relationships first.",
  successWithCount: (count: number) =>
    `${count} entities have been successfully deleted.`,
};
